<template>
    <b-container fluid class="px-md-5">
        <h4 class="mt-4 p-2 text-center text-primary text-uppercase">Reporte Prefondeo Agentes</h4>
        <b-row class="justify-content-center">
            <b-col cols="12" class="mt-4 mb-2">
                <b-form-group class="mb-0">
                    <b-input-group size="sm">
                        <b-form-input id="search" v-model="search" type="search" placeholder="Buscar" class="pad-3-15 btlr-30 bblr-30"></b-form-input>

                        <b-input-group-append>
                            <b-button variant="default" :disabled="!search" @click="search = ''" class="m-0 btlr-0 bblr-0">
                                <i class="material-icons mdi mdi-close"></i>
                            </b-button>
                        </b-input-group-append>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col cols="12" class="px-0">
                <b-table
                    :items="items"
                    :fields="fields"
                    responsive="sm"
                    class="my-2 border-bottom"
                    stacked="sm"
                    hover
                    small
                    show-empty
                    no-border-collapse
                    table-variant="light"
                    details-td-class="px-0"
                    empty-filtered-text="No hay transacciones que coincidan con la búsqueda"
                    empty-text="No hay transacciones para mostrar"
                    :current-page="currentPage"
                    :per-page="perPage"
                    :filter="search"
                    :busy="isBusy"
                    @filtered="onFiltered">
                    <template #cell(actions)="row">
                        <div style="display: flex; gap: 5px;">
                            <b-button 
                                variant="primary" 
                                size="sm" 
                                @click="getViewer(row.item.id)" 
                                :disabled="!row.item.voucher" 
                                v-b-modal.voucher 
                                title="Ver Voucher">
                                <i class="material-icons" style="font-size: 18px;">photo</i>
                            </b-button>
                            <b-button 
                                variant="danger" 
                                size="sm" 
                                @click="confirmCancel(row.item)" 
                                :disabled="row.item.status === 3 || row.item.status === '3'" 
                                title="Anular Prefondeo">
                                <i class="material-icons" style="font-size: 18px;">cancel</i>
                            </b-button>
                        </div>
                    </template>

                    <template #table-busy>
                        <div class="text-center text-danger my-4">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong>Actualizando...</strong>
                        </div>
                    </template>
                </b-table>

                <!-- Modal Voucher Viewer -->
                <b-modal
                    id="voucher"
                    centered
                    no-fade
                    header-class="text-center"
                    header-bg-variant="primary"
                    header-text-variant="light"
                    header-close-variant="light"
                    footer-class="border-0"
                    hide-footer
                    body-class="text-center px-4 my-4"
                    :title="'ID: '+id"
                    tabindex="-1"
                    role="dialog"
                    size="lg"
                    aria-hidden="true">
                    <img :src="'/'+voucher" :title="id" alt="Voucher" width="100%"/>
                </b-modal>

                <!-- Modal Confirm Cancel -->
                <b-modal
                    id="confirmCancel"
                    centered
                    no-fade
                    header-class="text-center"
                    header-bg-variant="danger"
                    header-text-variant="light"
                    header-close-variant="light"
                    footer-class="border-0"
                    :title="'Anular Prefondeo'"
                    @ok="cancelPrefondeo"
                    ok-variant="danger"
                    ok-title="Anular"
                    cancel-title="Cancelar">
                    <p class="my-4">¿Está seguro que desea anular el prefondeo <strong>ID: {{cancelId}}</strong>?</p>
                    <p class="text-danger"><small>Esta acción no se puede deshacer.</small></p>
                </b-modal>
            </b-col>
            <b-col sm="5" md="6">
                <b-form-group
                    label="Mostrar:"
                    label-for="per-page-select"
                    label-cols-sm="4"
                    label-cols-md="6"
                    label-cols-lg="9"
                    label-align-sm="right"
                    label-size="sm"
                    class="mt-2 mb-8">
                    <b-form-select
                        id="per-page-select"
                        v-model="perPage"
                        :options="pageOptions"
                        size="sm"
                    ></b-form-select>
                </b-form-group>
            </b-col>
            <b-col sm="7" md="6">
                <b-pagination
                    v-model="currentPage"
                    :total-rows="totalRows"
                    :per-page="perPage"
                    align="fill"
                    size="sm"
                    class="mt-2 mb-8"
                ></b-pagination>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>

import axios from "axios";

export default {
    name: "ReportBalance",
    props: [ 'user' ],
    data: () => ({
        id: 0,
        voucher: '',
        cancelId: 0,
        isBusy: true,
        search: '',
        fields: [
            { key: 'id', label: 'ID', sortable: true, thClass: 'text-sm-right', tdClass: 'text-sm-right' },
            { key: 'code', label: 'Código', sortable: true },
            { key: 'name', label: 'Agente', sortable: true },
            { key: 'amount_text', label: 'Valor', sortable: true, thClass: 'text-sm-right', tdClass: 'text-sm-right' },
            { key: 'currency', label: 'Moneda', sortable: true },
            { key: 'country_text', label: 'País', sortable: true },
            { key: 'date', label: 'Fecha', sortable: true },
            { key: 'actions', label: 'Acción', sortable: false, thClass: 'text-sm-center', tdClass: 'text-sm-center' }
        ],
        items: [],
        totalRows: 1,
        currentPage: 1,
        perPage: 25,
        pageOptions: [25, 50, 100, { value: -1, text: "Todos" }],
    }),
    mounted() {
        this.$emit('loader');
        this.$emit('section', 'balancepage');
        this.totalRows = this.items.length;
        this.getData();
    },
    methods: {
        getData() {
            axios.get('/api/admin/reports/partners/balance').then((res) => {
                if (res.data.status === 'success') {
                    this.items = res.data.items;
                    this.totalRows = this.items.length;
                    // Debug: verificar que los datos lleguen
                    if (this.items.length > 0) {
                        console.log('Primer item:', this.items[0]);
                    }
                }
            }).catch(err => {
                this.$root.$bvToast.toast(err.response.data.errors, {
                    title: 'Notificación',
                    headerClass: 'd-none',
                    variant: 'error',
                    toaster: 'b-toaster-top-right',
                    autoHideDelay: 5000,
                    solid: true,
                    appendToast: true
                });
            }).then(() => {
                this.isBusy = false;
            });
            this.timeout = setTimeout(this.getData, 180000);
        },
        getViewer(id) {
            this.id = id;
            const items = this.items;

            for (let i = 0; i < items.length; i++) {
                if (items[i].id === id) {
                    this.voucher = items[i].voucher;
                }
            }
        },
        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },
        confirmCancel(item) {
            this.cancelId = item.id;
            this.$bvModal.show('confirmCancel');
        },
        cancelPrefondeo() {
            axios.post('/api/admin/reports/partners/balance/' + this.cancelId + '/cancel').then((res) => {
                this.$root.$bvToast.toast(res.data.msg, {
                    title: 'Notificación',
                    headerClass: 'd-none',
                    variant: res.data.status,
                    toaster: 'b-toaster-top-right',
                    autoHideDelay: 5000,
                    solid: true,
                    appendToast: true
                });
                if (res.data.status === 'success') {
                    this.getData();
                }
            }).catch(err => {
                this.$root.$bvToast.toast(err.response?.data?.errors || err.response?.data?.msg || 'Error al anular el prefondeo', {
                    title: 'Notificación',
                    headerClass: 'd-none',
                    variant: 'error',
                    toaster: 'b-toaster-top-right',
                    autoHideDelay: 5000,
                    solid: true,
                    appendToast: true
                });
            });
        }
    },
    destroyed() {
        clearTimeout(this.timeout);
    }
}
</script>

<style scoped>

</style>
